// Purpose: orbital mesh — three concentric dashed circles centered
// off-right + four orbital nodes. Full-viewport SVG with
// preserveAspectRatio='xMidYMid slice' so the 1200x680 composition
// slices cleanly at any viewport.
//
// All colors + opacities driven by CSS vars so theme flip re-colors
// without state. Dark mode: three distinct ring colors (blue/indigo/
// violet). Light mode: all rings #1D4ED8 (variables.css handles the
// flip).

export interface OrbitalMeshProps {
  className?: string;
}

export function OrbitalMesh({ className }: OrbitalMeshProps) {
  return (
    <div
      aria-hidden
      className={['absolute inset-0 pointer-events-none opacity-orbital', className ?? ''].join(
        ' '
      )}
    >
      <svg
        viewBox="0 0 1200 680"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
      >
        {/* Three concentric rings centered at (920, 340). Dashed stroke
            so each ring reads as a rotating orbit rather than a
            continuous circle. */}
        <circle
          cx="920"
          cy="340"
          r="280"
          fill="none"
          stroke="var(--orbital-c1)"
          strokeWidth="0.4"
          strokeDasharray="2 10"
        />
        <circle
          cx="920"
          cy="340"
          r="200"
          fill="none"
          stroke="var(--orbital-c2)"
          strokeWidth="0.4"
          strokeDasharray="1 7"
        />
        <circle
          cx="920"
          cy="340"
          r="380"
          fill="none"
          stroke="var(--orbital-c3)"
          strokeWidth="0.3"
          strokeDasharray="1 12"
        />
        {/* Orbital nodes — four filled dots at asymmetric positions so
            the mesh reads as "live" rather than geometric. */}
        <circle cx="1200" cy="340" r="3" fill="var(--orbital-node-1)" />
        <circle cx="920" cy="140" r="2.5" fill="var(--orbital-node-2)" />
        <circle cx="720" cy="420" r="2.5" fill="var(--orbital-node-3)" opacity="0.7" />
        <circle cx="1080" cy="220" r="2" fill="var(--orbital-node-4)" opacity="0.5" />
      </svg>
    </div>
  );
}
